import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { setItemInStorage, getItemFromStorage, removeItemInStorage } from 'commons/localStorage';
import { LOGOUT } from '@/graphql/mutations';
import useIsBrowser from 'hooks/useIsBrowser';
import useUserData from 'data-hooks/useUserData';
import useLogoutClient from 'data-hooks/useUserData/useLogoutClient';
const IMPERSONATE_SESSION_COUNTER = 'impersonate-session-counter';
const ImpersonateHeader = () => {
  const $ = _c(5);
  const [logout] = useMutation(LOGOUT);
  const logoutClient = useLogoutClient();
  const [timeLeft, setTimeLeft] = useState(null);
  let t0;
  if ($[0] !== logout || $[1] !== logoutClient) {
    t0 = () => {
      let time = getItemFromStorage(IMPERSONATE_SESSION_COUNTER);
      if (!time) {
        time = Date.now();
        setItemInStorage(IMPERSONATE_SESSION_COUNTER, time);
      }
      const intervalId = setInterval(async () => {
        const diff = time ? 600 - (Date.now() - time) / 1000 : 0;
        if (diff <= 0) {
          await logout();
          logoutClient();
          removeItemInStorage(IMPERSONATE_SESSION_COUNTER);
          window.location.href = "/sign-in";
          return;
        }
        const secs = Math.floor(diff % 60);
        const mins = Math.floor(diff / 60 % 60);
        setTimeLeft(`${mins > 0 ? `${mins} min${mins !== 1 ? "s" : ""}` : ""} ${secs} secs`);
      }, 1000);
      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    };
    $[0] = logout;
    $[1] = logoutClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  useEffect(t0);
  let t1;
  if ($[3] !== timeLeft) {
    t1 = <div className="w-full py-2 px-0 flex justify-center items-center text-base font-bold text-white bg-red">Impersonate Session ends in {timeLeft}</div>;
    $[3] = timeLeft;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
const ImpersonateHeaderContainer = () => {
  const $ = _c(3);
  const {
    isImpersonatingUser
  } = useUserData();
  const isBrowser = useIsBrowser();
  let t0;
  if ($[0] !== isBrowser || $[1] !== isImpersonatingUser) {
    t0 = isBrowser && isImpersonatingUser && <ImpersonateHeader />;
    $[0] = isBrowser;
    $[1] = isImpersonatingUser;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default ImpersonateHeaderContainer;